// extracted by mini-css-extract-plugin
export var wordContainer = "_ls-0";